import { compile } from "path-to-regexp";
import { EngineEarsError } from "../../store/actions/errorStore";
import {
  makeBackendGetCallWithJsonResponse,
  makeBackendPutCallWithJsonResponse,
} from "../../store/utils/fetch";
import {
  PRODUCT_DETAILS_ROUTE,
  PRODUCTS_BY_RELEASE_ROUTE,
  USER_PRODUCTS_ROUTE,
} from "../../store/utils/routes";
import { promiseEngineEarsHandler } from "../helpers";
import { Product } from "./models";

export interface ProductResponse extends Product {
  product_purchased_by_current_user: boolean;
}
export const fetchProductsByReleaseId = async (releaseId: number) => {
  const route = compile(PRODUCTS_BY_RELEASE_ROUTE)({
    release_id: releaseId,
  });
  return await makeBackendGetCallWithJsonResponse<
    ProductResponse[] | EngineEarsError
  >(route, "");
};

export const fetchProductDetails = async (productId: number) => {
  const route = compile(PRODUCT_DETAILS_ROUTE)({
    product_id: productId,
  });

  return await makeBackendGetCallWithJsonResponse<Product>(route, "").then(
    promiseEngineEarsHandler,
  );
};

export interface UpdateProductDetailsArgs {
  total_price?: number;
  unit_price?: number;
  published_at?: string | null;
  published_end?: string | null;
  audio_download_mp3_enabled?: boolean | null;
  audio_download_wav_enabled?: boolean | null;
  pay_what_you_want: boolean;
  min_pay_what_you_want_price?: number;
  name?: string;
  cover_photo_id?: number | null;
  description?: string;
}

export const updateProductDetails = async (
  productId: number,
  args: UpdateProductDetailsArgs,
) => {
  const route = compile(PRODUCT_DETAILS_ROUTE)({
    product_id: productId,
  });
  return makeBackendPutCallWithJsonResponse<Product>(route, args).then(
    promiseEngineEarsHandler,
  );
};

export const fetchAllUserProducts = async (userId: number) => {
  const route = compile(USER_PRODUCTS_ROUTE)({ user_id: userId });

  return await makeBackendGetCallWithJsonResponse<ProductResponse[]>(
    route,
    "",
  ).then(promiseEngineEarsHandler);
};
